/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import styles from "../../Pages/Coupon/coupon.module.css";

const GenerateCoupon = ({ setCouponData, couponData, error, setError }) => {

    useEffect(() => {
        generateCode();
    }, []);

    const generateCode = () => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let text = "";

        for (let i = 0; i < 4; i++) {
            text += letters.charAt(Math.floor(Math.random() * letters.length));
        }

        const numbers = Math.floor(1000 + Math.random() * 9000);

        setCouponData(prev => ({
            ...prev,
            coupon: text + numbers
        }));
        setError(prev => ({ ...prev, coupon: "" }));
    };


    return (
        <div className={`${styles.couponData}`}>
            <div className={styles.couponGenerateSection}>
                <input
                    type="text"
                    value={couponData?.coupon}
                    onChange={(e) => {
                        setCouponData(prev => ({
                            ...prev,
                            coupon: e.target.value.replace(/\s+/g, "")
                        }));
                        setError(prev => ({ ...prev, coupon: "" }));
                    }}
                    className={styles.couponInput}
                />
                {error.coupon && <span className="error-message">{error.coupon}</span>}

                <button onClick={generateCode} className={styles.generateBtn}>
                    Generate coupon code
                </button>
            </div>

            <textarea
                placeholder="Description (optional)"
                className={styles.description}
                value={couponData?.description}
                onChange={(e) => {
                    setCouponData(prev => ({
                        ...prev,
                        description: e.target.value
                    }));
                }}
            />
        </div>
    );
};

export default GenerateCoupon;
